import * as React from 'react'
import { Spin, Result } from 'antd'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { useCurrentInvoice, usePaymentStatus } from './queries'

const PaymentContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  & .ant-descriptions-item-content {
    width: 100%;
  }
`

const Payment = () => {
  const invoiceQuery = useCurrentInvoice()
  const statusQuery = usePaymentStatus()
  const status = statusQuery.data?.status
  const paid = status === 'AUTHORIZED' || invoiceQuery.data?.status === 'PAID'

  React.useEffect(() => {
    const urlOk = statusQuery.data?.urlOk
    const urlFailed = statusQuery.data?.urlFailed
    if (status === 'AUTHORIZED' && !!urlOk) {
      setTimeout(() => {
        window.location.href = urlOk
      }, 3000)
    } else if (status === 'FAILED' && !!urlFailed) {
      setTimeout(() => {
        window.location.href = urlFailed
      }, 3000)
    }
  }, [status])

  return (
    <PaymentContent>
      {statusQuery.isLoading || invoiceQuery.isLoading ? (
        <Spin spinning={true} />
      ) : paid ? (
        <Result
          status="success"
          title={<FormattedMessage id="paymentSuccess" />}
        />
      ) : (
        <Result
          status="error"
          title={<FormattedMessage id="paymentFailed" />}
          subTitle={<FormattedMessage id="tryAgain" />}
        />
      )}
    </PaymentContent>
  )
}

export default Payment
